import { useQuery } from "hooks/useQuery";
import { getChartFetchData } from "../service";
import { getSectorPerfomanceFilteredData } from "../utils";
import { getHpLineColors } from "features/Strategy/utils";

export const useSectorPerformance = (period = "") => {
  const { isLoading, data } = useQuery({
    queryKey: ["sectorPerformance", period],
    queryFn: async () => {
      const response = await getChartFetchData({
        datasource_name: "sectorperformance",
        period,
      });

      const filteredData = getSectorPerfomanceFilteredData(
        response.external_data
      );

      const lineColors = getHpLineColors(filteredData);

      return {
        chartData: filteredData,
        chartLineColors: lineColors,
      };
    },
    enabled: true,
  });

  return {
    isLoading,
    chartData: data?.chartData || [],
    chartLineColors: data?.chartLineColors || [],
  };
};
